import capitalize from 'lodash/capitalize';
export const feedbackDetailsConfig = [{
  head: '',
  content: [{
    label: 'Application',
    apiKeyPath: 'applicationKey',
    format: value => capitalize(value.toString())
  }, {
    label: 'Hosting',
    apiKeyPath: 'hosting'
  }, {
    label: 'Message',
    apiKeyPath: 'message'
  }]
}];